<template>
    <div class="split-pane-wrapper">
        <div class="left-pane-container">
            <slot name="left-pane-content" />
        </div>

        <div class="right-pane-container">
            <slot name="right-pane-content" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss" scoped>
@import '../styles/design-language-variables';

.split-pane-wrapper {
    background: $background-color-default-content;
    display: inline-flex;
    width: 100%;

    // Fix the pane height to viewport (minus the nav) and let the sub
    // components manage their own scroll/overflow
    height: calc(100vh - var(--default-horizontal-nav-bar-height, 0));

    .left-pane-container {
        flex-grow: 1;
        border-right: 1px solid $border-grey;
        max-width: 720px;
        min-width: 50%;
    }

    .right-pane-container {
        flex-grow: 1;
        min-width: 50%;
    }
}
</style>
